import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
    token: string | null;
    agent: any | null;
}

const initialState: AuthState = {
    token: null,
    agent: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ token: string; agent: any }>) => {
            state.token = action.payload.token;
            state.agent = action.payload.agent;
        },
        logout: (state, action: PayloadAction<void>) => {
            state.token = null;
            state.agent = null;
        },
    },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
